export const esgDocumentModel = (data = {}) => ({
  id: data.id,
  uuid: data.uuid,
  name: data.name || "",
  description: data.description || "",
  version: data.version,
});
